import styled from "styled-components";

export const SuccessLayout = styled.div`
    display: grid;
    padding: 2.2rem 4rem;
    gap: 4rem;
    grid-auto-flow: row;
    justify-items: center;
`;
